import { createFileRoute } from "@tanstack/react-router"
import { openLogin, untilPageUnloads } from "src/sdk"

/**
 * Forwards to the API's login page. The app has no login form of its own; this route exists so that links which predate
 * that -- a bookmark, an old email -- land on a sign-in rather than a 404.
 */
export const Route = createFileRoute("/login")({
	beforeLoad: async () => {
		// Not the current URL, which is this route: the freshly signed-in user would be sent straight back here, to be
		// forwarded again.
		openLogin("/")
		await untilPageUnloads()
	},
})
